export const theme = {
  // 배경색, 글꼴 색
  bgColor: 'white',
  textColor: 'black',
  primaryBoldColor: '#FFA800',
  primaryColor: '#FFD98E',
  secondaryColor: '#FFF2D9',
  pointColor: '#603900',
};
